import { inclusionOptionMap } from "app/pages/sales-intelligence/types/commonMaps";

export const TRANSLATION_PREFIX = "si.lead_gen_filters.websiteType";
export const PREDEFINED_INCLUSION = inclusionOptionMap.includeOnly;
